export default __webpack_public_path__ + "static/media/favicon.8e025fe2.png";